function _objectWithoutProperties(a, b) {
  if (null == a) return {};

  var c,
      d,
      e = _objectWithoutPropertiesLoose(a, b);

  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);

    for (d = 0; d < f.length; d++) {
      c = f[d], !(0 <= b.indexOf(c)) && Object.prototype.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
    }
  }

  return e;
}

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _objectSpread(a) {
  for (var b = 1; b < arguments.length; b++) {
    var c = null == arguments[b] ? {} : arguments[b],
        d = Object.keys(c);
    "function" == typeof Object.getOwnPropertySymbols && (d = d.concat(Object.getOwnPropertySymbols(c).filter(function (a) {
      return Object.getOwnPropertyDescriptor(c, a).enumerable;
    }))), d.forEach(function (b) {
      _defineProperty(a, b, c[b]);
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

import React from "react";
import styled from "@emotion/styled";
import isPropValid from "@emotion/is-prop-valid";

var createInnerElements = function createInnerElements(a) {
  return a.map(function (a) {
    return React.createElement(a.type, _objectSpread({}, a.props));
  });
};

function calcRatio(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 1;
  if ("number" != typeof b) return a;
  if ("number" == typeof a) return a * b;
  var c = parseFloat(a);
  return c * b + a.replace("".concat(c), "");
}

var calcDimension = function calcDimension(a, b) {
  var c = b.size,
      d = b.ratio,
      e = _objectWithoutProperties(b, ["size", "ratio"]),
      f = e[a],
      g = c ? d ? calcRatio(c, d) : c : f ? d ? calcRatio(f, d) : f : null;

  return g ? _defineProperty({}, a, g) : {};
},
    createIcon = function createIcon(a) {
  var b = createInnerElements(a.body),
      c = styled("svg", {
    shouldForwardProp: function b(a) {
      return !["width", "size", "height", "css", "color"].includes(a) && isPropValid(a);
    }
  })(function (b) {
    var c = b.size,
        d = b.ratio,
        e = b.height,
        f = void 0 === e ? a.height : e,
        g = b.width,
        h = void 0 === g ? a.width : g,
        i = b.css,
        j = b.color,
        k = void 0 === j ? a.color : j;
    return _objectSpread({}, a.css, calcDimension("height", {
      size: c,
      ratio: d,
      height: f,
      width: h
    }), calcDimension("width", {
      size: c,
      ratio: d,
      height: f,
      width: h
    }), k ? {
      color: k
    } : {}, i);
  }),
      d = function d(_d) {
    var e = _d.title,
        f = _objectWithoutProperties(_d, ["title"]),
        g = _objectSpread({
      viewBox: a.viewBox,
      "aria-hidden": e ? null : "true",
      "aria-labelledby": e && a.labelledby,
      focusable: "false",
      role: e ? void 0 : "img"
    }, a.attrs, f);

    return React.createElement(c, g, e && React.createElement("title", {
      key: a.titleKey
    }, e), b);
  };

  return d.displayName = a.displayName, d.defaultProps = a.defaultProps, d;
};

export default createIcon;